<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0011 2.05399C6.50953 2.05399 2.05078 6.5127 2.05078 12.0046C2.05078 17.4966 6.50953 21.9553 12.0011 21.9553C17.4927 21.9553 21.9513 17.4966 21.9513 12.0046C21.9513 6.5127 17.4927 2.05399 12.0011 2.05399ZM12.0011 3.6386C16.6189 3.6386 20.3671 7.38733 20.3671 12.0046C20.3671 16.6219 16.6189 20.3706 12.0011 20.3706C7.38426 20.3706 3.63515 16.6219 3.63515 12.0046C3.63515 7.38733 7.38426 3.6386 12.0011 3.6386ZM12.0011 10.8841L9.42591 8.309C9.11665 7.99974 8.61423 7.99974 8.30498 8.309C7.99672 8.61825 7.99672 9.12027 8.30498 9.42953L10.8802 12.0046L8.30498 14.5797C7.99672 14.889 7.99672 15.391 8.30498 15.7003C8.61423 16.0095 9.11665 16.0095 9.42591 15.7003L12.0011 13.1251L14.5762 15.7003C14.8855 16.0095 15.3879 16.0095 15.6972 15.7003C16.0064 15.391 16.0064 14.889 15.6972 14.5797L13.122 12.0046L15.6972 9.42953C16.0064 9.12027 16.0064 8.61825 15.6972 8.309C15.3879 7.99974 14.8855 7.99974 14.5762 8.309L12.0011 10.8841Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StateRejected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
